import { Site } from '@envato/foundation-types'
import * as React from 'react'

import { ICommonLocation } from '../../../common/utils/location/types'
import FeatureContainer from '../../containers/feature'
import SearchResultsBody from '../../pages/search/result/searchResultBody'
import V0SearchResults from '../../v0/pages/search/result/searchResultBody'

import { IItem } from '../../../typings/searchResults'

import * as styles from './heroItemSection.module.css'

interface IProps {
  item: IItem
  location: ICommonLocation
  currentSite: Site
  viewType?: string
}

const HeroItemSection = ({
  item,
  location,
  currentSite,
  viewType = 'list'
}: IProps) => {
  const matches = [item]
  const photoDuneClass =
    currentSite === Site.photodune ? styles.photoHeroSection : ''
  return (
    <div className={styles.root}>
      <FeatureContainer name="!v0-featured-page">
        <div className={`${styles.v1HeroSection} ${photoDuneClass}`}>
          <SearchResultsBody
            location={location}
            matches={matches}
            viewType={viewType}
          />
        </div>
      </FeatureContainer>
      <FeatureContainer name="v0-featured-page">
        <div className={`${styles.v0HeroSection} ${photoDuneClass}`}>
          <V0SearchResults
            isHeroItem
            location={location}
            matches={matches}
            viewType={viewType}
          />
        </div>
      </FeatureContainer>
    </div>
  )
}

export default HeroItemSection
